import * as PropertyBucket from '../../Properties/Properties';
import * as httpService from '../../Components/HttpService/HttpService';

export function getKindsDataRequested() {
    return {
        type: 'GET_KINDS_DATA_REQUESTED'
    };
}

export function getKindsDataDone(data) {
    return {
        type: 'GET_KINDS_DATA_DONE',
        payload: data
    };
}

export function getKindsDataFailed(error) {
    return {
        type: 'GET_KINDS_DATA_FAILED',
        payload: error
    };
}

export function getKindsData() {
    let url = PropertyBucket.getKinds();
    return dispatch => {
        dispatch(getKindsDataRequested());
        let response = httpService.getService(url, "GET");
            response.then(data => {
                dispatch(getKindsDataDone(data));
            })
            .catch(error => {
                dispatch(getKindsDataFailed(error));
            })
    }
}

export function saveNewKind(data) {

    const request = () => {
        return {
            type: SAVE_NEW_KIND_DATA_REQUEST
        }
    };

    const success = (result) => {
        return {
            type: SAVE_NEW_KIND_DATA_SUCCESS,
            payload: result
        }
    };

    const error = (error) => {
        return {
            type: 'SAVE_NEW_KIND_DATA_FAILED',
            payload: error
        };
    };

    return function(dispatch) {
        let url = PropertyBucket.saveKinds();
        dispatch(request());

       httpService.getServicePromise(url, "POST", data).then(result => {
           dispatch(success(result))
       }).catch(err => dispatch(error(err)))
    }
}

export function updateActiveStatus(entryId, active) {

    const request = () => {
        return {
            type: UPDATE_KIND_DATA_REQUEST
        }
    };

    const success = (result) => {
        return {
            type: UPDATE_KIND_DATA_SUCCESS,
            payload: result
        }
    };

    const error = (error) => {
        return {
            type: 'UPDATE_KIND_DATA_FAILED',
            payload: error
        };
    };

    return function(dispatch) {
       let url = active ? 
        PropertyBucket.activateKind(entryId) :
        PropertyBucket.deactivateKind(entryId);

        dispatch(request());

       httpService.getServicePromise(url, "PUT").then(result => {
           dispatch(success(result))
       }).catch(err => dispatch(error(err)))
    }
}

export const GET_KINDS_DATA_REQUESTED = 'GET_KINDS_DATA_REQUESTED';
export const GET_KINDS_DATA_DONE = 'GET_KINDS_DATA_DONE';
export const GET_KINDS_DATA_FAILED = 'GET_KINDS_DATA_FAILED';

export const SAVE_NEW_KIND_DATA_REQUEST = 'SAVE_NEW_KIND_DATA_REQUEST';
export const SAVE_NEW_KIND_DATA_SUCCESS = 'SAVE_NEW_KIND_DATA_SUCCESS';
export const SAVE_NEW_KIND_DATA_FAILED = 'SAVE_NEW_KIND_DATA_FAILED';

export const UPDATE_KIND_DATA_REQUEST = 'UPDATE_KIND_DATA_REQUEST';
export const UPDATE_KIND_DATA_SUCCESS = 'UPDATE_KIND_DATA_SUCCESS';
export const UPDATE_KIND_DATA_FAILED = 'UPDATE_KIND_DATA_FAILED';